import { useCallback } from 'react';

import { useReactFlow } from 'reactflow';
import useTakeSnapshot from './useTakeSnapshot';

interface UseNodeExpandParams {
  id: string;
}

const useNodeExpand = ({ id }: UseNodeExpandParams) => {
  const { setNodes } = useReactFlow();
  const { takeSnapshot } = useTakeSnapshot();

  const handleExpandClick = useCallback(() => {
    takeSnapshot({ projectChange: false });
    setNodes((prevNodes) => {
      const newNodes = prevNodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: {
              ...node.data,
              expand: !node.data.expand,
            },
          };
        }
        return node;
      });

      return newNodes;
    });
  }, [id, setNodes, takeSnapshot]);

  return {
    onExpandClick: handleExpandClick,
  };
};

export default useNodeExpand;
